<template>
  <div>  
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 250px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="p-field p-col"
            v-for="(obj, index) in actionButtons1" 
            :key="index"
            style="margin: 0px; text-align: center; padding: 0px;"
          >
            <Button 
              :label="obj.label" 
              :icon="obj.icon"
              :disabled="obj.disabled ? obj.disabled : false"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
        <hr />
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in actionButtons2" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable 
      :key="tableKey"
      :value="contacts"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rowHover="true"
      :selection.sync="selectedContacts"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Contacts"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="tableSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
      <template #empty> No contacts found. </template>
      <template #loading> Loading contacts data. Please wait. </template>
      <div
        :key="columnsKey"
      > 
        <!-- <Column selectionMode="multiple" headerStyle="width: 3em;"></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 39.85px; padding: 10px 0px; display: flex; align-items: center;"
            >
              <Button 
                icon="pi pi-ellipsis-h" 
                class="p-button-rounded p-button-text"
                @click="toggleActions($event, slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <Column 
          v-for="(col, index) of colSelectedFieldsForTable" 
          :key="col.dbField + '_' + index"
          :field="getOptionLabel(col)[0]" 
          :sortField="sortKeyOf(col, colSelectedFieldsForTable)"
          :header="col.fieldName" 
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'" 
        >
          <template #body="slotProps">
            <div
              style="height: 40px; padding: 10px 0px;"
              @click="openOP(slotProps.data, col, $event)"
              :class="getStyle2(col)"
            >
              {{ getToShow(slotProps.data, col) }}
            </div>
          </template>
        </Column>
        <!-- <Column 
          headerStyle="width: 9em;"
        >
          <template #body="slotProps">
            <div
              class="splitButtonColumn"
              :style="{position: 'absolute'}"
            >
              <SplitButton 
                label="View" 
                icon="pi pi-info" 
                @click="viewContact(slotProps.data)" 
                :model="getButtons(slotProps.data)"
              >
              </SplitButton>
            </div>
          </template>
        </Column> -->
      </div>
    </DataTable>

    <div class="flex justify_space_between my-1">
      <div>
      </div>
      <div 
        style="width: 250px; display: flex; justify-content: flex-end;" 
      >
        <ProgressSpinner
          v-if="makingExport"
          style="width:100%; height:25px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Export Contacts to Excel"
          icon="pi pi-external-link"
          style="width: 210px;"
          @click="$emit('exportData')"
        />
      </div>
    </div>

    <ContextMenu :model="getButtons(selectedRow)" ref="cm" />

    <Dialog header="Success" :visible.sync="deleteConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Do you want to delete this contact: {{ tempObj.contactName }}</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="deleteConfirmation = false" class="p-button-text" />
        <Button label="Ok" icon="pi pi-check" @click="deleteConfirmation = false, $emit('delete-contact', tempObj)" class="p-button-text" autofocus />
      </template>
    </Dialog>

  </div>
</template>

<script>
import { columnSortKey, sortChangeFor, restoreSortKey } from '@/mbp/universalComponents/listSort'
import { formatCurrency } from '@/utils/money'
import FiltersService from "@/service/FiltersSerice"
import CustomerService from "@/service/CustomerService"
import ContactService from "@/service/ContactService";

import HistoryTable from '../customer/customerHistoryTable'

import {
  columnSelectionRequest
} from '../sendRequest'

export default {
  components: {
    HistoryTable
  },
  created() {
    

    this.actionButtons1.push(
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: (that) => {
          that.deleteContact(that.selectedRow)
        }
      }
    )
      
    this.setupComponent()
  },
  mounted() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  updated() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  props: [
    'dbView',
    'contacts', 
    'loading',
    "colSelectedFieldsForTable", 
    "colSelectedFields", 
    "dbViewFields",
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'makingExport',
    'storeName'
  ],
  data() {
    return {
      filtersService: new FiltersService(),
      customerService: new CustomerService(),
      contactService: new ContactService(),
      selectedContacts: null,
      selectedRow: null,
      selected: [],
      tempCustomer: {},
      previousPage: null,
      tableKey1: 0,
      columnsKey1: 0,
      customerHistory: [],
      customerHistoryLoading: false,
      
      defaultSortField: '',
      
      defaultSortFieldId: null,
      defaultSortOrder: 0,
      defaultFirstPage: 1,
      defaultRows: 25,
      sendingRequest: false,

      actionButtons1: [
        {
          label: 'View',
          icon: 'pi pi-info',
          command: (that) => {
            that.viewContact(that.selectedRow)
          }
        },
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: (that) => {
						that.editContact(that.selectedRow)
					}
				}
      ],
      actionButtons2: [
      ],
      tempObj: {},
      deleteConfirmation: false
    }
  },
  computed: {
    /** C2: the saved sort, shown on the right column when columns share a db_field last segment. */
    tableSortField() {
      return restoreSortKey(this.defaultSortField, this.defaultSortFieldId, this.colSelectedFieldsForTable)
    },
    splitButtonLocationReset() {
      return this.$store.getters.getSplitButtonLocationReset
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  watch: {
    splitButtonLocationReset(val) {
      this.setSplitButtonLocations()
    },
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    contacts(val) {
      this.columnsKey++
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        this.setSplitButtonLocations()
        columnSelectionRequest(this, 'ContactsTableForLazyLoadingWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {
      
      this.columnsKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      
      if (
        event 
        && event.originalEvent 
        && event.originalEvent.target 
        && (
          event.originalEvent.target.classList.contains("under_lined")
          ||
          event.originalEvent.target.classList.contains("ignore")
        )
      ) {
        return
      } else {
        this.viewContact(event.data)
      }
    },
    setSplitButtonLocations() {
      // getElementsByClassName gives an HTMLCollection, which has no forEach (it threw on every list load).
      let a = Array.from(document.getElementsByClassName('splitButtonColumn'))
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    setupComponent() {
      
      
      if (this.$store.getters[this.storeName + '/getSortField']) {
        this.defaultSortField = this.$store.getters[this.storeName + '/getSortField']
        this.defaultSortOrder = this.$store.getters[this.storeName + '/getSortOrder']
        this.defaultSortFieldId = this.$store.getters[this.storeName + '/getSortFieldId']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
        this.defaultSortFieldId = null
      }

      this.defaultRows = this.$store.getters[this.storeName + '/getRows']
      this.defaultFirstPage = (this.$store.getters[this.storeName + '/getPage'] - 1) * this.defaultRows

    },
    onSort(event) {
      // C2: one sort, for the column clicked (by its own key, then its id), not every column sharing the last db_field segment
      const change = sortChangeFor(event, this.colSelectedFieldsForTable)
      if (change) this.$emit('sortChange', change)
    },
    sortKeyOf(col, cols) {
      return columnSortKey(col, cols)
    },
    onPage(event) {
      
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      // 
      
      if (
        (
          col.dbField === 'custName' || col.dbField === 'customer.custName'
        ) 
        && data && data.customerId 
        && event.target && event.target.className === "under_lined"
      ) {
        this.tempCustomer = data
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    getStyle2(col) {
      if (
        col.dbField === 'custName' || col.dbField === 'customer.custName'
      ) {
        return 'under_lined'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        if (data[a[0]]) {
          b = data[a[0]][a[1]]
        } else if (data[a[1]]) {
          b = data[a[1]]
        } else {
          b = ''
        }
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.editContact(data)
					}
				}
      ]

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteContact(data)
          }
        }
      )
      return buttons
    },
    viewContact(contact) {
      this.contactService
        .getContact(contact.contactId)
        .then(data => {
          contact = data
          this.$store.dispatch('contacts/setContactDetailsForTab', contact)
          this.$router.push({
              path: "contacts/" + contact.contactId + "/detail",
              params: { contactId: contact.contactId }
          });
        })
        .catch(err => {
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while getting contact",
            life: 5000,
          })
        })
     
    },
    deleteContact(contact) {
      this.tempObj = contact
      this.deleteConfirmation = true
    },
    editContact(contact) {
      this.$emit('edit-contact', contact)
    }
  }
}
</script>

<style scoped>

</style>
